module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<button class="close transparent pos-top-right" data-click="support-close" aria-label="Close"><i class="icon icon-material icon-small icon-close"></i></button><h4 class="icon icon-labelled icon-material icon-small icon-wrench">'+
((__t=( i18n.tc("SupportPanel", "Support") ))==null?'':__t)+
'</h4><div data-region="support-search"></div><div class="response-wrap"><div class="response-container" data-region="support-response"></div></div>';
}
return __p;
};
